<template>
  <article v-if="pony" class="info-section elr-container-full">
    <div class="elr-row">
      <div class="elr-col-full">
        <section>
          <div class="pony-details-section">
            <PonyHeading :pony="pony" />
            <PonyStats :pony="pony" />
            <PonyListActions :pony="pony" :authenticated="authenticated" />
          </div>
        </section>
        <section>
          <PonyImages
            :images="pony.images"
            :slug="pony.slug"
          />
        </section>
        <section>
          <GroupingDetails :grouping="pony" />
          <ItemButtons
            @onRemoveItem="remove"
            model="pony"
            :item="pony"
            :user="user"
          />
        </section>
        <section>
          <PonyInfo :pony="pony" />
        </section>
        <section v-if="(pony.accessories && pony.accessories.length) || (authenticated && user.role_id > 4)">
          <div class="accessories-section">
            <InfoSectionHeading
              v-if="pony.accessories && pony.accessories.length"
            >Accessories</InfoSectionHeading>
            <PonyAccessories
              v-if="pony.accessories && pony.accessories.length"
              :accessories="pony.accessories"
            />
            <button
              class="elr-button elr-button-primary"
              @click.prevent="showAccessoryModal = true"
              v-if="authenticated && (user.role_id > 4)"
            >Add an Accessory</button>
          </div>
        </section>
        <section v-if="pony.related && pony.related.length">
          <div class="group-ponies-section">
            <GroupPonies
              :ponies="pony.related"
              :user="user"
              :authenticated="authenticated"
            />
          </div>
        </section>
        <section v-if="pony.variants && pony.variants.length">
          <div class="pony-variants-section">
            <InfoSectionHeading>Variants of {{pony.name}}</InfoSectionHeading>
            <VariantPonies
              :ponies="pony.variants"
              :user="user"
              :authenticated="authenticated"
            />
          </div>
        </section>
        <!-- <section v-if="comments && comments.length">
          <div class="comments-section">
            <InfoSectionHeading>Comments</InfoSectionHeading>
            <Pony-Comments
              :comments="comments"
            />
          </div>
        </section> -->
      </div>
    </div>
    <ModalWindow
      @close="showAccessoryModal = false"
      v-if="showAccessoryModal"
      modalId="accessoryModal"
      :showFooter="false"
      heading="Add a Accessory"
    >
      <FormAccessoryCreate :ponyId="id" @submitted="handleAddAccessory" @error="handleError" />
    </ModalWindow>
  </article>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { showPrompt } from '../../utils/helpers'
import PonyHeading from '../../components/PonyHeading/PonyHeading';
import PonyImages from '../../components/PonyImages/PonyImages';
import PonyInfo from '../../components/PonyInfo/PonyInfo';
import PonyStats from '../../components/PonyStats/PonyStats';
import PonyListActions from '../../components/PonyListActions/PonyListActions';
import GroupingDetails from '../../components/GroupingDetails/GroupingDetails';
import GroupPonies from '../../components/GroupPonies/GroupPonies';
import VariantPonies from '../../components/VariantPonies/VariantPonies';
import ItemButtons from '../../components/ItemButtons/ItemButtons';
import PonyAccessories from '../../components/PonyAccessories/PonyAccessories';
// import PonyComments from '../../components/PonyComments/PonyComments';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import ModalWindow from '../../components/ModalWindow/ModalWindow';
import FormAccessoryCreate from '../../components/FormAccessoryCreate/FormAccessoryCreate';

export default {
  name: 'Pony',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pony: null,
      showAccessoryModal: false,
    }
  },
  components: {
    PonyAccessories,
    // PonyComments,
    PonyHeading,
    PonyImages,
    PonyInfo,
    PonyListActions,
    GroupingDetails,
    GroupPonies,
    VariantPonies,
    PonyStats,
    ItemButtons,
    InfoSectionHeading,
    ModalWindow,
    FormAccessoryCreate,
  },
  async mounted() {
    if (this.slug) {
      this.pony = await this.fetchPony({ slug: this.slug });
    }
  },
  computed: {
    ...mapState('currentUser', {authenticated: 'authenticated', user: 'currentUser'}),
  },
  methods: {
    ...mapActions('pony', { fetchPony: 'FETCH' }),
    async handleAddAccessory() {
      this.pony = await this.fetchPony({ slug: this.slug });
      this.showAccessoryModal = false;
    },
    handleError({ errors }) {
      if (!errors || errors.length === 0) {
        this.showAccessoryModal = false;
      }
    },
    hasPony() {
      return Object.keys(this.pony).length;
    },
    remove() {
      showPrompt();

      // remove pony and return to PonyList
    },
  },
  watch: {
    async id() {
      if (this.slug) {
        this.pony = await this.fetchPony({ slug: this.slug });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.button-holder {
  display: flex;
  justify-content: center;
  width: 100%;

  .elr-button {
    margin: 0 5px;
    display: block;
  }
}

.accessories-section,
.comments-section,
.group-ponies-section,
.pony-variants-section {
  border-top: 1px solid $accent-color;
  // border-bottom: 1px solid $accent-color;
  margin-top: 20px;
  padding-top: 20px;
}

</style>
